import type * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type GetCubeJsTokenQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCubeJsTokenQuery = { identityServerUserScopes?: Maybe<{ __typename?: 'UserScopesResult', status: boolean, cubeJsJwtToken?: Maybe<string> }> };


export const GetCubeJsTokenDocument = gql`
    query getCubeJSToken {
  identityServerUserScopes {
    status
    cubeJsJwtToken
  }
}
    `;

/**
 * __useGetCubeJsTokenQuery__
 *
 * To run a query within a React component, call `useGetCubeJsTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCubeJsTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCubeJsTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCubeJsTokenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCubeJsTokenQuery, GetCubeJsTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCubeJsTokenQuery, GetCubeJsTokenQueryVariables>(GetCubeJsTokenDocument, options);
      }
export function useGetCubeJsTokenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCubeJsTokenQuery, GetCubeJsTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCubeJsTokenQuery, GetCubeJsTokenQueryVariables>(GetCubeJsTokenDocument, options);
        }
export type GetCubeJsTokenQueryHookResult = ReturnType<typeof useGetCubeJsTokenQuery>;
export type GetCubeJsTokenLazyQueryHookResult = ReturnType<typeof useGetCubeJsTokenLazyQuery>;
export type GetCubeJsTokenQueryResult = Apollo.QueryResult<GetCubeJsTokenQuery, GetCubeJsTokenQueryVariables>;
export type PartialResultType<T> = Types.PartialResultType<T>;
export type ResultType<T> = Types.ResultType<T>;
export type PaginatedResultType<T> = Types.PaginatedResultType<T>;
export type NonMaybe<T> = Types.NonMaybe<T>;
export type Maybe<T> = Types.Maybe<T>;
